import { SmartfireComponent, smartProps } from '@smartfire/gutenberg-react';
import './style.scss';
import * as React from 'react';
import PlusButton from '../plus-button/block.js';
import { PanelBody, TextControl } from '@wordpress/components';
import { ReactComponent as Phone } from './phone.svg';

export default class PreFooterBlock extends SmartfireComponent {
    static title = 'Bloc contactez-nous';

    static smartProps = {
        phoneNumber: smartProps.any.withDefault(''),
    };

    renderEditInspector() {
        return (
            <PanelBody title={SmartfireComponent.__('Numéro de téléphone')}>
                <TextControl
                    label="Numéro de téléphone"
                    value={this.props.phoneNumber}
                    onChange={(phoneNumber) => this.setAttributes({ phoneNumber })}
                />
            </PanelBody>
        );
    }

    render() {
        return (
            <div className="prefooter-block">
                <div className="content-container">
                    <div className="columns">
                        <div className="column">
                            <p className="title">Contactez-nous</p>
                            <p className="subTitle">
                                Les équipes CAPSA Container restent à votre écoute !
                            </p>
                        </div>
                        <div className="column">
                            <div className="phone">
                                <Phone />
                                <a
                                    href={
                                        'tel:' +
                                        (this.props.phone
                                            ? this.props.phone
                                            : this.props.phoneNumber)
                                    }
                                >
                                    {this.props.phone
                                        ? this.props.phone
                                        : this.props.phoneNumber}
                                </a>
                            </div>
                            <div className="button">
                                <PlusButton
                                    buttonText="Demande de devis"
                                    color="white"
                                    event="devis"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
